import React from 'react';
import { Row, Col, Tooltip, Typography, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import formatPrice from '~helpers/currency';
import { dayFormatType, formatDay } from '~client/helpers/day';
import { landlordBookingStatus } from 'common/constants/booking';

export default function Header({ orderInfo = {} }) {
  const { t } = useTranslation(['landlord']);
  const { student } = orderInfo;

  const renderTooltipContainer = text => (
    <div className="longtail-booking-details__tooltip-container">
      <span className="longtail-booking-details__tooltip-container__text">{text}</span>
    </div>
  );

  return (
    <div className="header">
      <div className="longtail-booking-details__header-container">
        <div className="longtail-booking-details__crumb">
          <Link to="/booking">{t('landlord.header.menu_link.booking.list')}</Link>
          <span className="longtail-booking-details__slash">/</span>
          <span className="longtail-booking-details__current">
            {t('landlord.header.menu_link.booking.details')}
          </span>
        </div>
        <Row style={{ paddingBottom: '24px', display: 'flex', alignItems: 'flex-end' }}>
          <Col span={16}>
            <div className="header__title">
              <h3 className="header__booking-number">
                {`${t('landlord.long_tail.booking_details.title.booking_number')} - ${
                  orderInfo?.referenceId
                }`}
              </h3>
              {orderInfo?.landlordApplicationId && (
                <>
                  <Tag className="commison-plan__plan-card__basic-info__default-tag">
                    <span className=" header__tag-txt">
                      {t('cms:cms.properties.homepage.property_management.external_id')}
                    </span>
                    <span> {orderInfo?.landlordApplicationId}</span>
                  </Tag>
                </>
              )}
            </div>
            <div className="longtail-booking-details__student-info">
              <Row className="longtail-booking-details__info-row" gutter={50}>
                <Col span={12} className="longtail-booking-details__info-col">
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('landlord.long_tail.booking_details.label.student_name', {
                        value: `${
                          student?.passportFirstName
                            ? student?.passportFirstName + ' ' + student?.passportLastName
                            : '-'
                        }`,
                      }),
                    )}
                  >
                    <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                      {t('landlord.long_tail.booking_details.label.student_name', {
                        value: `${
                          student?.passportFirstName
                            ? student?.passportFirstName + ' ' + student?.passportLastName
                            : '-'
                        }`,
                      })}
                    </Typography.Paragraph>
                  </Tooltip>

                  <div className="longtail-booking-details__info">
                    {t('landlord.long_tail.booking_details.label.student_mobile', {
                      value: student?.phoneNumber ?? '-',
                    })}
                  </div>

                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('landlord.long_tail.booking_details.label.student_email', {
                        value: student?.emailAddress ?? '-',
                      }),
                    )}
                  >
                    <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                      {t('landlord.long_tail.booking_details.label.student_email', {
                        value: student?.emailAddress ?? '-',
                      })}
                    </Typography.Paragraph>
                  </Tooltip>
                  <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                    {t('cms:cms.landlord.detail.landlord_name.label')}:&nbsp;
                    {orderInfo?.interestedXbooking?.landlordName ?? '-'}
                  </Typography.Paragraph>
                  <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                    {t('cms:cms.landlord.detail.owner_bc.label')}
                    :&nbsp;
                    {orderInfo?.contacts?.name ?? '-'}
                  </Typography.Paragraph>
                  <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                    {t('cms:cms.landlord.detail.ref_no.label')}:&nbsp;
                    {orderInfo?.referenceId ?? '-'}
                  </Typography.Paragraph>
                  <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                    {t('cms:cms.landlord.detail.Completed Date.label')}:&nbsp;
                    {(orderInfo?.completedAt &&
                      formatDay(dayFormatType.UKWITHHM, orderInfo?.completedAt)) ||
                      '-'}
                  </Typography.Paragraph>
                </Col>
                <Col
                  span={12}
                  className="longtail-booking-details__info-col"
                  style={{ width: 'auto', marginLeft: 0, paddingLeft: 0 }}
                >
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('landlord.long_tail.booking_details.label.room') +
                        (orderInfo?.interestedXbooking?.roomType
                          ? t(
                              `landlord.long_tail.booking.unit_type_category.${orderInfo?.interestedXbooking?.roomType.toLowerCase()}`,
                            )
                          : '') +
                        (orderInfo?.interestedXbooking?.roomName
                          ? `, ${orderInfo?.interestedXbooking?.roomName}`
                          : '') +
                        (orderInfo?.interestedXbooking?.propertyName
                          ? `, ${orderInfo?.interestedXbooking?.propertyName}`
                          : ''),
                    )}
                  >
                    <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                      {t('landlord.long_tail.booking_details.label.room')}
                      {orderInfo?.interestedXbooking?.roomType
                        ? t(
                            `landlord.long_tail.booking.unit_type_category.${orderInfo?.interestedXbooking?.roomType.toLowerCase()}`,
                          )
                        : ''}
                      {orderInfo?.interestedXbooking?.roomName
                        ? `, ${orderInfo?.interestedXbooking?.roomName}`
                        : ''}
                      {orderInfo?.interestedXbooking?.propertyName
                        ? `, ${orderInfo?.interestedXbooking?.propertyName}`
                        : ''}
                    </Typography.Paragraph>
                  </Tooltip>
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('landlord.long_tail.booking_details.label.move_in_date', {
                        value: orderInfo?.finalMoveInDate
                          ? moment(orderInfo?.finalMoveInDate).format('DD/MM/YYYY')
                          : '-',
                      }),
                    )}
                  >
                    <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                      {t('landlord.long_tail.booking_details.label.move_in_date', {
                        value: orderInfo?.finalMoveInDate
                          ? moment(orderInfo?.finalMoveInDate).format('DD/MM/YYYY')
                          : '-',
                      })}
                    </Typography.Paragraph>
                  </Tooltip>
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('landlord.long_tail.booking_details.label.move_out_date', {
                        value: orderInfo?.finalMoveOutDate
                          ? moment(orderInfo?.finalMoveOutDate).format('DD/MM/YYYY')
                          : '-',
                      }),
                    )}
                  >
                    <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                      {t('landlord.long_tail.booking_details.label.move_out_date', {
                        value: orderInfo?.finalMoveOutDate
                          ? moment(orderInfo?.finalMoveOutDate).format('DD/MM/YYYY')
                          : '-',
                      })}
                    </Typography.Paragraph>
                  </Tooltip>
                  {/* <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                    {t('landlord.long_tail.booking_details.label.bc_name', {
                      value: orderInfo?.contacts?.name ?? '-',
                    })}
                  </Typography.Paragraph> */}
                  <Tooltip
                    overlayClassName="longtail-booking-details__info-tooltip"
                    placement="topLeft"
                    trigger="hover"
                    overlay={renderTooltipContainer(
                      t('cms:cms.landlord.detail.landlord_booking_status.label', {
                        value:
                          landlordBookingStatus.find(
                            item => item.value === orderInfo?.landlordBookingStatus,
                          )?.text ?? '-',
                      }),
                    )}
                  >
                    <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                      {t('cms:cms.landlord.detail.landlord_booking_status.label', {
                        value:
                          landlordBookingStatus.find(
                            item => item.value === orderInfo?.landlordBookingStatus,
                          )?.text ?? '-',
                      })}
                    </Typography.Paragraph>
                  </Tooltip>

                  <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                    {t('cms:cms.landlord.detail.partner_code.label', {
                      value: orderInfo?.partnerCode ?? '-',
                    })}
                  </Typography.Paragraph>
                  <Typography.Paragraph ellipsis className="longtail-booking-details__info">
                    {t('cms:cms.landlord.detail.created_date.label', {
                      value:
                        (orderInfo?.createdAt &&
                          formatDay(dayFormatType.UKWITHHM, orderInfo?.createdAt)) ||
                        '-',
                    })}
                  </Typography.Paragraph>
                </Col>
              </Row>
            </div>
          </Col>
          <Col span={8}>
            <div className="longtail-booking-details__booking-info">
              <div className="longtail-booking-details__price-info">
                <label className="longtail-booking-details__label">
                  {t('landlord.long_tail.booking_details.label.total_price')}
                </label>

                <p className="longtail-booking-details__value">
                  {orderInfo?.finalPrice
                    ? formatPrice(orderInfo?.finalPrice, orderInfo?.currency)
                    : '-'}
                </p>
              </div>
              <div className="longtail-booking-details__status-info">
                <label className="longtail-booking-details__label">
                  {t('landlord.long_tail.booking_details.label.booking_status')}
                </label>
                <p className="longtail-booking-details__value">
                  {orderInfo?.stage
                    ? t(
                        `landlord.long_tail.booking.booking_status.${orderInfo?.stage.toLowerCase()}`,
                      )
                    : '-'}
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
